import React, { useEffect, useState } from "react";
import "./CollegeManagement.css";

function CollegeManagement() {
  const [adminData, setAdminData] = useState(null);

  // ✅ Load admin info from localStorage (set by login)
  useEffect(() => {
    const loggedInAdmin = JSON.parse(localStorage.getItem("loggedInAdmin"));
    if (loggedInAdmin) {
      setAdminData(loggedInAdmin);
    }
  }, []);

  return (
    <div className="college-section">
      <div className="welcome-container">
        {/* Left: Welcome Text */}
        <div className="welcome-text">
          <h2>Welcome 🎉</h2>
          <p>
            Hello, <strong>{adminData?.adminName || "Admin"}</strong> from{" "}
            <strong>{adminData?.college || "Your College"}</strong>!
          </p>
        </div>

        {/* Right: Illustration Image */}
        <div className="welcome-image">
          <img src="/admin.jpg" alt="Admin Illustration" />
        </div>
      </div>
    </div>
  );
}

export default CollegeManagement;

